module.exports = __webpack_public_path__ + "static/5-a79a5f38bb7c8a47e85ad49bf3fbfe48.png";